import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "../../css/CloseButton.css";

const ClosingButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className="close-button" aria-label="Close">
      <FontAwesomeIcon icon={faXmark} size="lg" />
    </button>
  );
};

export default ClosingButton;
